export enum AdvancedBookingActionEnum {
  DELETE = "Delete",
  HIDE_CARD = "Hide card",
  SAVE_AS_FAVORITE = "Save as favorite",
  REMOVE_FROM_FAVORITE = "Remove from favorite",
  COPY = "Copy",
  COPIED = "Copied",
}
